// dependencies
import React, { useState } from "react";

// components
import SidebarItem, { NavItem } from "./SidebarItem";

// styles
import css from "./VerticalNavBar.module.scss";

export interface BaseProps {
	/**
	 * Optional class name to add to the text element
	 */
	className?: string;
	/**
	 * Nav items to display in the sidebar
	 */
	navItems: NavItem[];
}

const VerticalNavBar = (props: BaseProps) => {
	const { className, navItems } = props;

	const [isSidebarOpen, setIsSideBarOpen] = useState(false);
	const [openNavs, setOpenNavs] = useState<string[]>([]);

	return (
		<div
			data-testid="verticalNavBar"
			className={`${css.sidebar} ${className || ""}`}
			onMouseLeave={() => setIsSideBarOpen(false)}
			onMouseEnter={() => setIsSideBarOpen(true)}
		>
			{navItems.map((item, index) => (
				<React.Fragment key={index}>
					{item.divider === "before" && index > 0 ? (
						<div data-testid="verticalNavBarDivider" className={css.divider} />
					) : null}
					<SidebarItem
						item={item}
						isSidebarOpen={isSidebarOpen}
						openNavs={openNavs}
						setOpenNavs={setOpenNavs}
					/>
				</React.Fragment>
			))}
		</div>
	);
};

export default VerticalNavBar;
